<template>
    <div>
        <v-title title="会诊信息" style="margin-left: -15px"></v-title>
        <el-form ref="form" :model="form" label-width="70px" label-position="left" size="mini">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="会诊医院">
                        <el-select v-model="form" placeholder="会诊医院">
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="会诊科室">
                        <el-select v-model="form" placeholder="会诊科室">
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="会诊医生">
                        <el-select v-model="form" placeholder="会诊医生">
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="申请医生">
                        <el-select v-model="form" placeholder="申请医生">
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="医生电话">
                        <el-input v-model="form.name" placeholder="医生电话"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
  import VTitle from "../common/v-title";

  export default {
    name: "diagnose-consultation-form",
    components: {VTitle},
    props: {
      value: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        form: {}
      }
    },
  }
</script>

<style scoped lang="scss">

</style>
